const defaultActiveFilters = {
    listFilters: [],
    rangeFilters: [],
    booleanFilters: [],
    multiListFilters: [],
    __typename: 'ActiveFilters'
};
export { defaultActiveFilters };
//# sourceMappingURL=defaultActiveFilters.js.map